import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as SearchIcon } from "../../assets/img/search.svg";
import { ReactComponent as FilterIcon } from "../../assets/img/filter.svg";
import { ReactComponent as EditIcon } from '../../assets/img/Edit.svg';
import { useRecoilState, useRecoilValue } from "recoil";
import { ReactComponent as DeleteIcon } from '../../assets/img/Delete.svg';
import AddIcon from '@mui/icons-material/Add';
import Checkbox from '@mui/material/Checkbox';
import configParam from '../../config';
import { Collapse, IconButton, Typography, TableCell } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { DataGrid, GridCellParams } from '@mui/x-data-grid';
import { plantId } from '../../recoil/atoms';
import {
  AppBar,
  Toolbar,
  Button,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DatePicker from '@mui/lab/DatePicker';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ImageIcon from '@mui/icons-material/Image';
import axios from "axios";
import CaptureImage from './CaptureImage';
import { db, saveInspectionOffline, saveDraft, loadDraft, clearDraft } from '../../services/db';

import { useNavigate, useLocation } from "react-router-dom";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
const moment = require('moment');
const areas = ['Area 1', 'Area 2', 'Area 3'];
const remarks = ['Accessible', 'Not access', 'Not in contact', 'Others'];
const filter = createFilterOptions();
const modalStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const modalContentStyle = {
  backgroundColor: '#fff',
  padding: 20,
  maxWidth: 500,
  width: '90%',
  maxHeight: '80vh',
  overflow: 'auto',
};

const modalInputLabelStyle = {

  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 500,
  color: '#000',
};
const imageStyle = {
  width: '100%', // Set the width to 100% of its container
  height: 'auto',  // Let the height adjust to maintain the aspect ratio
  display: 'block', // Remove any extra spacing or borders
};
const currentday = new Date().toISOString().split('T')[0];

const AddTrialOffline = ({ open, onclose, selectedRowData, currenttrialData, trialData, onHandleTrial, onHandleTrialDetails, onSubmit, resetFormFields, onShowAlertMessage }) => {
  const navigate = useNavigate();
  const [area, setArea] = useState(null);
  const [description, setDescription] = useState('');
  const [zone, setZone] = useState('');
  const [xrfNumber, setXrfNumber] = useState('');
  const [Ni, setNi] = useState('');
  const [remarksValue, setRemarksValue] = useState('');
  const [comments, setComments] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [trailData, setTrailData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [expanded, setExpanded] = useState([]);
  const [areaData, setAreaData] = useState([]);
  const fileInputRef = useRef(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [stream, setStream] = useState(null);
  const datauser=localStorage.getItem("user_id")
  let data = localStorage.getItem('user');
  let User = null;
  try {
    User = (data && data !== "undefined") ? JSON.parse(data) : null;
  } catch (e) {
    console.error("Error parsing user in AddTrialOffline.js component:", e);
  }
  const userlogoutdata = datauser != null ? datauser : (User && User.plant_id ? User.plant_id[0] : null);
  const [trialTableData, setTrialTableData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [descriptionData, setDescriptionData] = useState([]);
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedDescription, setSelectedDescription] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [imagePath, setImagePath] = useState('');
  const [imageFilePath, setImageFilePath] = useState('');
  const [openImageModal, setOpenImageModal] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageData, setImageData] = useState('');
  const [imageFileData, setImageFileData] = useState('');
  const [fileData, setFileData] = useState('');
  const [expandedRowData, setExpandedRowData] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessageImage, setErrorMessageImage] = useState('');
  const [errorMessageDescription, setErrorMessageDescription] = useState('');
  const [errorMessageZone, setErrorMessageZone] = useState('');
  const [errorMessageXrf, setErrorMessageXrf] = useState('');
  const [errorMessageNi, setErrorMessageNi] = useState('');
  const [errorMessageRemark, setErrorMessageRemark] = useState('');
  const [errorMessageComments, setErrorMessageComments] = useState('');
  const [errorMessageDate, setErrorMessageDate] = useState(null);
  const [inputValueZone, setInputValueZone] = useState('');
  const [inputZone, setInputZone] = useState(null);
  const [isInputValueZoneInitialized, setInputValueZoneInitialized] = useState(false);
  const [formValid, setFormValid] = useState(true);
  const [PlantId, setPlantId] = useRecoilState(plantId);
  const [userDet, setUserDet] = useState({});
  const [isCursorInsideDialog, setIsCursorInsideDialog] = useState(false);
  const [cloudActive, setCloudActive] = useState(false);
  const [captureActive, setCaptureActive] = useState(false);
  const [areaDataStatus,setareaDataStatus]=useState(false);
  // const [zoneTableData, setZoneTableData] = useState(zonetabledetails);
  const [imgid, setImgid] = useState(null);
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  const allzonedetails = localStorage.getItem('allzoneData');
  let storedzoneArray = null;
  try {
    storedzoneArray = (allzonedetails && allzonedetails !== "undefined") ? JSON.parse(allzonedetails) : null;
  } catch (e) {
    console.error("Error parsing allzoneData in AddTrialOffline.js:", e);
  }

  const allareadetails = localStorage.getItem('allareaData');
  let storedareaArray = null;
  try {
    storedareaArray = (allareadetails && allareadetails !== "undefined") ? JSON.parse(allareadetails) : null;
  } catch (e) {
    console.error("Error parsing allareaData in AddTrialOffline.js:", e);
  }
  const dbName = 'nis';
  const areaName = 'area';
  const zoneName = 'zone';
  const imageName = 'image';
  const trialName = 'trial';
  const trialDetailsName = 'trialDetails';

  // useEffect(() => {
  //   if (!isOnline) {
  //       const request = indexedDB.open(dbName, 1);

  //       request.onupgradeneeded = (event) => {
  //         const database = event.target.result;
  
         
  //           database.createObjectStore(areaName, { keyPath: 'id', autoIncrement: true });
       
        
  //           database.createObjectStore(zoneName, { keyPath: 'id', autoIncrement: true });
        
          
  //           database.createObjectStore(imageName, { keyPath: 'id', autoIncrement: true });
        
         
  //           database.createObjectStore(trialName, { keyPath: 'id', autoIncrement: true });
         
          
  //           database.createObjectStore(trialDetailsName, { keyPath: 'id', autoIncrement: true });
         
  //       };
  
  //       request.onsuccess = (event) => {
  //         const database = event.target.result;
  
  //         setDb(database);
  //         insertDataIntoarea(database,storedareaArray,areaName)
  //         insertDataIntoZone(database,storedzoneArray,zoneName)
  //         // deleteAllDataFromArea(database,areaName)
  //         // deleteAllDataFromZone(database,zoneName)
  //       };
  
  //       request.onerror = (event) => {
  //         console.error('Error opening IndexedDB', event);
  //       };
     
     
  //   }
  // }, [isOnline]);

  // useEffect(() => {
  //   if(isOnline){    
  //     deleteAllDataFromArea(db,areaName)
  //     deleteAllDataFromZone(db,zoneName)
  //   }
  //   }, [isOnline]);
  const saveFileToDB = async (file) => {
    try {
      const fileData = await file.arrayBuffer();
      if (currenttrialData && currenttrialData.id) {
        // Edit mode: update existing image
        await db.image.put({
          id: currenttrialData.image.id,
          name: file.name,
          type: file.type,
          size: file.size,
          data: fileData
        });
      } else {
        // Create mode: add new image
        const id = await db.image.add({
          name: file.name,
          type: file.type,
          size: file.size,
          data: fileData
        });
        setImgid(id);
      }
    } catch (error) {
      console.error('Error saving image in IndexedDB via Dexie:', error);
    }
  };
  const ApiURL = configParam.API_URL;
  useEffect(() => {
    if (canvasRef.current) {
      // Set the canvas dimensions to the window's inner width and outer width
      canvasRef.current.width = window.innerWidth;
      canvasRef.current.height = window.outerHeight;
     
    }
  }, []);
  // Load draft form state when opening the dialog
  useEffect(() => {
    if (open) {
      if (currenttrialData && currenttrialData.id) {
        // Do not load drafts if editing an existing record
      } else {
        const loadFormDraft = async () => {
          try {
            const draft = await loadDraft();
            if (draft) {
              setArea(draft.area || null);
              setDescription(draft.description || '');
              setZone(draft.zone || '');
              setXrfNumber(draft.xrfNumber || '');
              setNi(draft.Ni || '');
              setRemarksValue(draft.remarksValue || remarks[0]);
              setComments(draft.comments || '');
              setSelectedDate(draft.selectedDate || currentday);
              setImgid(draft.imgid || null);
              setImagePath(draft.imagePath || '');
              if (draft.inputValueZone) {
                setInputValueZone(draft.inputValueZone);
              }
            } else {
              setSelectedDate(currentday);
              setRemarksValue(remarks[0]);
            }
          } catch (e) {
            console.error("Error loading draft form state:", e);
          }
        };
        loadFormDraft();
      }
    }
  }, [open]);

  // Auto-save form state to drafts table on changes
  useEffect(() => {
    if (open && (!currenttrialData || !currenttrialData.id)) {
      const draftState = {
        area,
        description,
        zone,
        xrfNumber,
        Ni,
        remarksValue,
        comments,
        selectedDate,
        imgid,
        imagePath,
        inputValueZone
      };
      saveDraft(draftState).catch(err => console.error("Error saving draft:", err));
    }
  }, [open, area, description, zone, xrfNumber, Ni, remarksValue, comments, selectedDate, imgid, imagePath, inputValueZone]);

  const handleCloudClick = () => {
    setCloudActive(true)
  }
  const handleCaptureCamera = async () => {
    setCaptureActive(true);
    // navigate('/CaptureImage');
    // if (fileInputRef.current && videoRef.current) {
    //   try {
    //     // Attempt to access the back camera
    //     const mediaStreamBack = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });

    //     // Set the camera stream to the video element
    //     videoRef.current.srcObject = mediaStreamBack;

    //     // Save the stream for later cleanup
    //     setStream(mediaStreamBack);

    //     videoRef.current.play();
    //   } catch (error) {
    //     console.error('Error accessing back camera:', error);

    //     try {
    //       // If accessing the back camera fails, try accessing the front camera
    //       const mediaStreamFront = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } });

    //       // Set the camera stream to the video element
    //       videoRef.current.srcObject = mediaStreamFront;

    //       // Save the stream for later cleanup
    //       setStream(mediaStreamFront);

    //       videoRef.current.play();
    //     } catch (error) {
    //       console.error('Error accessing front camera:', error);
    //       // Handle the error as needed
    //     }
    //   }
    // }
  };


  // Add this function to stop the camera stream
  const stopCameraStream = () => {
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
      setStream(null);
    }
  };

  const handleTakePicture = () => {
    if (videoRef.current && canvasRef.current) {
      const context = canvasRef.current.getContext('2d');
      context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);

      // Stop the camera stream
      stopCameraStream();

      // Convert the captured image to a data URL
      const imageData = canvasRef.current.toDataURL('image/png');

      // Handle the captured image data here
   

      // Process the captured image using the setUploadedFile function
      setUploadedFile({ target: { files: [dataURLtoFile(imageData)] } });
      setCaptureActive(false)
      setCloudActive(false)
    }
  };

  // Add this function to convert data URL to a file
  function dataURLtoFile(dataURL) {
    const arr = dataURL.split(',');
    const mimeRegex = /:([\w\/+-]+);/;
    const mimeMatch = arr[0].match(mimeRegex);
    const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], 'captured-image.png', { type: mime });
  }


  const generateImagesArray = async (file) => {
    const imagesData = [];
  
    const reader = new FileReader();
    reader.onloadend = async () => {
      const imageType = file.type.split('/')[1];
      const imageBase64 = reader.result.split(',')[1];
      const imageName = `image_${Date.now()}.${imageType}`;
      imagesData.push({
        imageName,
        imageBase64,
        imageType,
      });
      setImagePath(`data:image/${imageType};base64,`+imageBase64);
      // Call the upload function after processing the images
    };
  
    reader.readAsDataURL(file);
  };

  const handleCaptureGallery = () => {
    // Open the gallery for image selection
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the input element to open the gallery
      fileInputRef.current.onchange = (e) => {

        const selectedFile = e.target.files[0];
  
        if(selectedFile){
          if (!selectedFile.type.startsWith("image/")) {
            setErrorMessageImage('please upload valid image')
          }
          else{
            setErrorMessageImage('')
            generateImagesArray(selectedFile);
        saveFileToDB(selectedFile)
          }
        }
       
      };
      setCaptureActive(false)
      setCloudActive(false)
    }
  };

  useEffect(() => {
    let data = localStorage.getItem("user");
    let User = null;
    try {
      User = (data && data !== "undefined") ? JSON.parse(data) : null;
    } catch (e) {
      console.error("Error parsing user in AddTrialOffline.js useEffect:", e);
    }
    setUserDet(User || {});
  }, []);
  const handleAreaChange = (event) => {
    setArea(event.target.value);
    getDescriptionDetails(event.target.value);
    getzoneDetails(event.target.value);
  };


  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handleZoneChange = (event) => {
    setZone(event.target.value);;
  };
  const handleZoneUpdateChange = (event, newValue) => {
    setZone(newValue ? newValue.id : null);
  };
  const handleXrfNumberChange = (event) => {
  
    const inputValue = event.target.value;

    // Use a regular expression to check if the input is an integer
    if (/^\d*$/.test(inputValue)) {
      setXrfNumber(inputValue);
      setErrorMessageXrf('');
    } else {
      setErrorMessageXrf('Please enter only numeric values for XRF Reference Number.');
    }

  };

  const handleNiChange = (event) => {
    const inputValue = event.target.value;

    // Regular expression to allow only numbers and float values
    const regex = /^(?!^\.)([0-9]*(\.[0-9]*)?)?$/;

    if (regex.test(inputValue) || inputValue === '') {
      setNi(inputValue);
      setErrorMessageNi('');
    } else {
      setErrorMessageNi('Please enter only numbers and decimals.');
    }
   
  };

  const handleRemarksChange = (event) => {
    const selectedRemark = event.target.value;

    if (selectedRemark === 'Others' || selectedRemark === 'Not access') {
      setNi('0'); // Set Ni% to 0
      setXrfNumber('');
    }
  
  // Update the state variable for the selected remark
  setRemarksValue(selectedRemark);

  };

  const handleCommentsChange = (event) => {
    setComments(event.target.value);
  };

  const [addingNewZone, setAddingNewZone] = useState(false);
  const [newZoneValue, setNewZoneValue] = useState('');

  const handleAddNewZone = () => {
    const newtrial = { newZoneValue, area }
    if (newZoneValue) {
      axios
        .post(ApiURL + '/create_zone', newtrial) // Replace '/create_area' with your backend API endpoint to save the area data
        .then((response) => {
          getzoneDetails(area);
        })
        .catch((error) => {
          // Handle error
          console.error('Failed to save area:', error);
        });
      setAddingNewZone(false);
      setNewZoneValue('');

    }
  };

  const handleClose = () => {
    setArea(null);
    setDescription('');
    setZone('');
    setXrfNumber('');
    setNi('');
    setComments('');
    setImagePath('');
    setRemarksValue('');
    setSelectedDate(null);
    setErrorMessage('');
    setErrorMessageDescription('');
    setErrorMessageZone('');
    setErrorMessageNi('');
    setErrorMessageXrf('');
    setImageData('');
    setErrorMessageImage('');
    setErrorMessageComments('');
    setErrorMessageRemark('');
    setErrorMessageDate(null);
    stopCameraStream();
    setCaptureActive(false)
    setCloudActive(false)
    setOpenDialog(false)
    // resetFormFields();
    onclose();
  };

  const handleDateChange = (event) => {
    const dateTimeString = event.target.value; // Use default value if date is invalid
    const formattedDate = moment.utc(dateTimeString).format("YYYY-MM-DD");
    const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

    if (formattedDate > today) {
      setErrorMessageDate("You cannot select a future date.");
    } else {
      setErrorMessageDate('');
      setSelectedDate(formattedDate);
    }
  };


  const setUploadedFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImagePath(URL.createObjectURL(file));
      saveFileToDB(file);
    } else {
      setImagePath('');
    }
  };

  function generateUniqueUUID(existingUUIDs) {
    let newUUID;
    let isUnique = false;
  
    while (!isUnique) {
        newUUID = uuidv4(); // Generate a new UUID
        isUnique = !existingUUIDs.some(uuidObj => uuidObj.id === newUUID);
    }
  
    return newUUID;
  }

  const handleSubmit = async () => {
    const idlist = JSON.parse(localStorage.getItem("trialdetailsallid")) || [];
 
    // Clear previous validation error messages
    setErrorMessageDate('');
    setErrorMessage('');
    setErrorMessageDescription('');
    setErrorMessageZone('');
    setErrorMessageImage('');
    setErrorMessageXrf('');
    setErrorMessageNi('');
    setErrorMessageRemark('');
    setErrorMessageComments('');

    if (
      !selectedDate ||
      !area ||
      !description ||
      (!zone && !inputValueZone) ||
      (!imagePath && !selectedRowData) ||
      (remarksValue !== 'Others' && remarksValue !== 'Not access' && !xrfNumber) ||
      (remarksValue !== 'Others' && remarksValue !== 'Not access' && !Ni)
    ) {
      if (!selectedDate) setErrorMessageDate('Please select a date.');
      if (!area) setErrorMessage('Please select an area.');
      if (!description) setErrorMessageDescription('Please enter a description.');
      if (!zone && !inputValueZone) setErrorMessageZone('Please select a zone.');
      if (!imagePath && !selectedRowData) setErrorMessageImage('Please add a image');
      if (remarksValue !== 'Others' && remarksValue !== 'Not access' && !xrfNumber) setErrorMessageXrf('Please enter an XRF reference number.');
      if (remarksValue !== 'Others' && remarksValue !== 'Not access' && !Ni) setErrorMessageNi('Please enter Ni%.');
      if (!remarksValue) setErrorMessageRemark('Please select a remark.');
      if (remarksValue !== 'Accessible' && !comments) setErrorMessageComments('Please enter comments.');
      if (remarksValue === 'Others' || remarksValue === 'Not access') {
        setErrorMessageXrf('');
        setErrorMessageNi('');
      }
      return;
    }

    try {
      if (currenttrialData && currenttrialData.id) {
        // Edit mode: update zone and trialDetails transactionally via Dexie
        await db.transaction('rw', [db.zone, db.trial, db.trialDetails], async () => {
          await db.zone.put({
            id: currenttrialData.zone.id,
            area_id: area,
            zone: (inputValueZone && inputValueZone.zone) ? inputValueZone.zone : (inputValueZone || ''),
            created_at: selectedDate
          });

          await db.trialDetails.put({
            id: currenttrialData.id,
            trial_id: currenttrialData.trial_id,
            zone_id: (inputValueZone && inputValueZone.id) ? inputValueZone.id : currenttrialData.zone.id,
            img_id: currenttrialData.image.id,
            xrfNumber: xrfNumber,
            Ni: Ni,
            remarksValue: remarksValue,
            comments: comments,
            date: selectedDate,
            name: userDet.id
          });
        });
        
        onShowAlertMessage('inspection updated successfully');
        onHandleTrialDetails();
      } else {
        // Add mode: save new inspection offline
        const selectedZoneId = zone ? zone.id : null;
        const customZone = selectedZoneId ? null : {
          id: uuidv4(),
          zone: (zone && zone.inputValue) ? zone.inputValue : (inputValueZone || ''),
          area_id: area,
          created_at: selectedDate
        };

        const newTrialId = uuidv4();
        const newTrialDetailsId = generateUniqueUUID(idlist);

        const formData = {
          id: newTrialDetailsId,
          trial_id: newTrialId,
          area_id: area,
          zone_id: selectedZoneId || customZone.id,
          xrfNumber: xrfNumber,
          Ni: Ni,
          remarksValue: remarksValue,
          comments: comments,
          date: selectedDate,
          name: userDet.id,
          img_id: imgid
        };

        await saveInspectionOffline(formData, null, customZone);

        onShowAlertMessage('inspection created successfully');
        onHandleTrialDetails();
      }

      // Reset Form State
      setArea(null);
      setDescription('');
      setInputValueZone(null);
      setXrfNumber('');
      setNi('');
      setZone('');
      setComments('');
      setRemarksValue('');
      setSelectedDate(null);
      setImageData('');
      setImagePath('');
      setImgid(null);
      onclose();
      setErrorMessage('');
      setErrorMessageDescription('');
      setErrorMessageZone('');
      setErrorMessageXrf('');
      setErrorMessageNi('');
      setErrorMessageRemark('');
      setErrorMessageComments('');
      setErrorMessageImage('');
      setErrorMessageDate(null);

      // Clear Draft from IndexedDB
      await clearDraft();

    } catch (error) {
      console.error("Failed to save inspection to IndexedDB:", error);
      alert("Error saving inspection details offline.");
    }
  };
  useEffect(() => {
    if (!isOnline && currenttrialData && currenttrialData.id) {
      const fetchData = async () => {
        const selectedArea = currenttrialData.area ? areaData.find((option) => option.area === currenttrialData.area.area) : null;
        setArea(selectedArea ? selectedArea.id : null);
        setDescription(selectedArea ? selectedArea.description : null);
        if (selectedArea) {
          try {
            await getzoneDetails(selectedArea.id);
            const selectedZone = currenttrialData.zone ? zoneData.find((option) => option.zone === currenttrialData.zone.zone) : null;
            setInputValueZone(selectedZone || null);
            if (!isInputValueZoneInitialized) {
              setInputValueZoneInitialized(true);
            }
          } catch (error) {
            console.error("Error fetching zone details:", error);
          }
        }

        const xrfNumber = currenttrialData.xrfNumber || '';
        const ni = currenttrialData.Ni || '';
        const comments = currenttrialData.comments || '';

        const dateTimeString = currenttrialData.date || '';
        setSelectedDate(dateTimeString);

        setXrfNumber(xrfNumber);
        setNi(ni);
        setComments(comments);
        const selectedRemarks = currenttrialData.remarksValue || '';
        setRemarksValue(selectedRemarks);
      };
      fetchData();
    }

  }, [currenttrialData, isOnline, areaData]);

  useEffect(() => {
    if (isInputValueZoneInitialized) {
  
      // Additional logic or state updates that depend on inputValuePlant
    }
  }, [inputValueZone, isInputValueZoneInitialized]);

  // useEffect(() => {
  //   getimageDetails();

  //   // getImageFileDetails(imageData);

  // }, []);

  // const getimageDetails = () => {
  //   let url = ApiURL + '/show_image';
  //   axios.get(url).then((response) => {
  //     setImageFileData(response.data);
  //   }).catch((error) => {
  //     setImageFileData([]);
  //   });
  // };
  const deleteTrialImage = (imageName) => {
    const url = ApiURL + `/delete_image/${encodeURIComponent(imageName)}`; // Replace with your backend API endpoint to delete area
    axios
      .delete(url)
      .then((response) => {

      })
      .catch((error) => {
        // Handle error
        console.error('Failed to delete image:', error);
      });
  };
  useEffect(() => {
    if (open) {
      getareaDetails();
    }
  }, [open]);

  const getareaDetails = async () => {
    try {
      const allData = await db.area.toArray();
      console.log('[Offline] area table count:', allData.length);
      setAreaData(allData);
    } catch (event) {
      setAreaData([]);
      console.error('Error getting data from the area table in Dexie', event);
    }
  };

  const getzoneDetails = async (areazone) => {
    try {
      const allData = await db.zone.toArray();
      const filteredRecords = allData.filter(record => record.area_id === areazone);
      setZoneData(filteredRecords);
    } catch (event) {
      setZoneData([]);
      console.error('Error getting data from the zone table in Dexie', event);
    }
  };

  const getDescriptionDetails = async (areazone) => {
    try {
      const record = await db.area.get(areazone);
      if (record) {
        setDescription(record.description || '');
      } else {
        setDescription('');
      }
    } catch (e) {
      setDescription('');
      console.error('Error getting data from the area table in Dexie', e);
    }
  };
  const handleInputChange = (event, newInputValue) => {
    setInputValueZone({ id: inputValueZone?.id || null, zone: newInputValue });
    setInputZone(newInputValue);
  };
  const renderZoneField = () => {
    if (selectedRowData) {
      return (
        <div>
          <Autocomplete
            className="autocomplete-nis"
            size="small"
            value={inputValueZone}
            onChange={(event, newValue) => {
              setInputValueZone(newValue);
              setInputZone(newValue ? newValue.zone : ''); // Clear the input when an option is selected
            }}
            inputValue={inputZone}
            onInputChange={handleInputChange}
            options={zoneData}
            getOptionLabel={(option) => option.zone}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Type something"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </div>
      )
    }
    else {
      return (
        <div>
          <Autocomplete
            className="autocomplete-nis"
            size="small"
            value={zone}
            onChange={(event, newValue) => {
              setZone(newValue);
            }}

            filterOptions={(options, params) => {
              const filtered = filter(options, params);

              // Suggest creating a new option if the user input doesn't match any options
              if (params.inputValue !== '' && !filtered.length) {
                filtered.push({
                  inputValue: params.inputValue,
                  title: `Add "${params.inputValue}"`,
                });
              }

              return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="my-autocomplete"
            options={zoneData}
            getOptionLabel={(option) => {
              if (typeof option === 'string') {
                return option;
              }
              if (option.inputValue) {
                return option.inputValue;
              }
              return option.zone;
            }}
            renderOption={(props, option) => (
              <li {...props}>
                {option.inputValue ? `Add "${option.inputValue}"` : option.zone}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select or Add Option"
                variant="outlined"
                fullWidth
              />
            )}
            style={{ marginBottom: 16 }}
          />
        </div>)
    }
  };
  const today = new Date().toISOString().split('T')[0];

  const handleSubmissionInCapture = () => {
    setCaptureActive(false);
    setCloudActive(false)
    setOpenDialog(true); // Set this to true if you want to open the dialog
    // navigate('/view'); // Navigate back to the view
  };
  return (
    <Dialog open={open || openDialog} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pb: 1, fontSize: '18px', fontWeight: 600, color: '#0f172a' }}>
        {currenttrialData.length > 0 ? 'Edit Inspection Offline' : 'New Inspection Offline'}
      </DialogTitle>
      <DialogContent className={`dialog-content ${isCursorInsideDialog ? 'show-scroll' : ''}`}
        onMouseEnter={() => {
          setIsCursorInsideDialog(true);
        }}
        onMouseLeave={() => {
          setIsCursorInsideDialog(false);
        }}>
        {captureActive ? (
          <CaptureImage handleSubmission={handleSubmissionInCapture} setUploadedFile={setUploadedFile} dataURLtoFile={dataURLtoFile} />
        ) : (<div>
          {cloudActive && !captureActive && (
            <div>
              <canvas
                ref={canvasRef}
                style={{ display: 'none' }}
              />
              <video
                ref={videoRef}
                style={{ width: '100%', height: 'auto' }}
                autoPlay
                playsInline
              />
              <input  id="upload-image" multiple type="file" style={{ display: 'none' }} onChange={setUploadedFile} ref={fileInputRef} />
              {/* Button to select from gallery */}
              <button onClick={handleCaptureGallery}>Select from Gallery</button>
            </div>

          )}

          {!cloudActive && !captureActive && (
            <div>
              <div>
                {errorMessageImage && <p style={{ color: 'red', marginBottom: '16px' }}>{errorMessageImage}</p>}
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<CloudUploadIcon />}
                  onClick={handleCloudClick}
                  sx={{
                    width: '100%',
                    height: '40px',
                    borderRadius: '8px',
                    borderColor: '#e2e8f0',
                    color: '#0f172a',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    mb: 2,
                    '&:hover': {
                      borderColor: '#002060',
                      backgroundColor: '#f8fafc'
                    }
                  }}
                >
                  Upload Image
                  {(selectedRowData || imageData) && (
                    <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                  )}
                </Button>
              </div>
              <div>
                {(imagePath) && (
                  <img
                    src={imagePath}
                    alt="Selected Image"
                    style={imageStyle}
                  />
                )}

              </div>
            </div>
          )}

          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>
            Date
          </Typography>
          <div style={{ marginBottom: "16px" }}>
            {errorMessageDate && <p style={{ color: 'red', marginBottom: '16px' }}>{errorMessageDate}</p>}
            <TextField
              size="small" className="input-nis"
              fullWidth
              id="date"
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              inputProps={{ max: today }}
            />
            {errorMessage && <p style={{ color: 'red', marginBottom: '16px' }}>{errorMessage}</p>}
          </div>

          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>
            Area
          </Typography>
          <FormControl fullWidth size="small" style={{ marginBottom: 16 }}>
            <Select labelId="area-label" className='select-nis' value={area} onChange={handleAreaChange}>
              {areaData.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.area}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>
            Description
          </Typography>
          {errorMessageDescription && <p style={{ color: 'red', marginBottom: '16px' }}>{errorMessageDescription}</p>}
          <TextField size="small" className="input-nis"
            value={description}
            multiline
            onChange={handleDescriptionChange}
            fullWidth
            style={{ marginBottom: 16 }}
            disabled={true}
          />

          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>
            Zone
          </Typography>
          {errorMessageZone && <p style={{ color: 'red', marginBottom: '16px' }}>{errorMessageZone}</p>}
          <div style={{ marginBottom: '16px' }}>
            {renderZoneField()}
          </div>

          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>
            XRF Reference Number
          </Typography>
          {errorMessageXrf && <p style={{ color: 'red', marginBottom: '16px' }}>{errorMessageXrf}</p>}
          <TextField size="small" className="input-nis"
            value={xrfNumber}
            onChange={handleXrfNumberChange}
            fullWidth
            style={{ marginBottom: 16 }}
            disabled={remarksValue === 'Others' || remarksValue === 'Not access'}
          />

          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>
            Ni%
          </Typography>
          {errorMessageNi && <p style={{ color: 'red', marginBottom: '16px' }}>{errorMessageNi}</p>}
          <TextField size="small" className="input-nis"
            value={Ni}
            onChange={handleNiChange}
            fullWidth
            style={{ marginBottom: 16 }}
            disabled={remarksValue === 'Others' || remarksValue === 'Not access'}
          />

          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>
            Remark
          </Typography>
          {errorMessageRemark && <p style={{ color: 'red', marginBottom: '16px' }}>{errorMessageRemark}</p>}
          <FormControl fullWidth size="small" style={{ marginBottom: 16 }}>
            <Select
              value={remarksValue}
              onChange={handleRemarksChange}
              fullWidth
              className='select-nis'
            >
              <MenuItem value="">Select a remark</MenuItem>
              {remarks.map((remark, index) => (
                <MenuItem key={index} value={remark}>
                  {remark}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>
            Comments
          </Typography>
          {errorMessageComments && <p style={{ color: 'red', marginBottom: '16px' }}>{errorMessageComments}</p>}
          <TextField
            size="small"
            className="input-nis"
            value={comments}
            onChange={handleCommentsChange}
            fullWidth
            style={{ marginBottom: 16 }}
          />
        </div>
        )}
      </DialogContent>
      <DialogActions sx={{ borderTop: '1px solid #e2e8f0', padding: '12px 24px' }}>
        <Button 
          variant="outlined" 
          onClick={handleClose} 
          sx={{ 
            mr: 1.5, 
            color: '#475569', 
            borderColor: '#cbd5e1',
            borderRadius: '6px',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
              borderColor: '#94a3b8',
              backgroundColor: '#f8fafc'
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          variant="contained" 
          onClick={handleSubmit} 
          sx={{ 
            backgroundColor: '#002060',
            borderRadius: '6px',
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            '&:hover': {
              backgroundColor: '#001a4e'
            }
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTrialOffline;